module.exports = __webpack_public_path__ + "img/jxsy4.16f9f3cd.jpg";